import { getSelectedLanguage } from './language';

/**
 * Format the date to the current language.
 * @param {string} date - The date to format.
 * @returns {string} - The formatted date.
 * @private
 */
export const formatCardDate = (date) => {
    /** @type {Intl.DateTimeFormatOptions} */
    const options = { year: 'numeric', month: 'long', day: 'numeric' };

    return handleDateFromInputsFormat(date)
        .toLocaleDateString(getSelectedLanguage(), options)
        .replace(/ de/g, '');
};

/**
 * Format the date to the filter.
 * @param {string} date - The date to format.
 * @returns {string} - The formatted date.
 */
export const formatFilterDate = (date) => {
    date = new Date(date);
    date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

    return date;
};

/**
 * Handle the date from inputs format to the correct format.
 * @param {string} date - The date.
 * @returns {Date} - The date.
 */
export const handleDateFromInputsFormat = (date) => {
    if (date.includes('-')) {
        date = new Date(date);
        date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    /** @type {Array<string>} */
    const splitDate = date.split('/');

    return new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
};

/**
 * Get the date from the UTC date.
 * @param {Date} date - The date.
 * @returns {string} - The date.
 */
export const getOnlyDateFromUTCDate = (date) => {
    return date.toISOString().split('T')[0];
};

/**
 * Fix the wrong date formats.
 * @param {string} date - The date.
 * @returns {string} - The date.
 */
export const fixWrongDateFormats = (date) => {
    if (date.includes('-')) {
        date = new Date(date);
        date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    if (date.includes('/')) {
        const splitDate = date.split('/');
        date = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
    }

    return date;
};

/**
 * Check if the date is valid.
 * @param {string} date - The date.
 * @returns {boolean} - The date is valid.
 */
export const isValidDate = (date) => {
    const /** @type {Date} */ currentDate = handleDateFromInputsFormat(date);

    return currentDate > new Date(1900, 0, 1) && currentDate < new Date();
};

/**
 * Get the n days before today.
 * @param {number} n The n days before today.
 * @returns The date n days before today.
 */
export const getNDaysBeforeToday = (n) => {
    const date = new Date();
    date.setDate(date.getDate() - n);

    return date;
};
